module.exports = __webpack_public_path__ + "static/media/madison.8380c306.png";